import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const knowledgeHubArticleInCategoryRoute: InvariantJiraRoute = {
	name: 'knowledge-hub-article-in-category',
	path: '/jira/servicedesk/projects/:projectKey/knowledge/categories/:categoryId/articles/:articleId',
};
